// extracted by mini-css-extract-plugin
export default {"list":"brands-list_list__PkvoB","listItem":"brands-list_listItem__ZV7Oz"};